<template>
  <div>
    <div class="feature-pill" role="navigation" aria-label="">
      <a class="feature-item" href="#img-1">
        <div class="label">先装后付</div>
        <div class="value">开工0预付，满意再结算</div>
      </a>
      <a class="feature-item" href="#img-2">
        <div class="label">信息透明</div>
        <div class="value">口碑全透明，好坏不隐瞒</div>
      </a>
      <a class="feature-item" href="#img-3">
        <div class="label">在线履约</div>
        <div class="value">全程在线监控，装修不扯皮</div>
      </a>
      <a class="feature-item" href="#img-4">
        <div class="label">售后保障</div>
        <div class="value">严守国家标准，售后问题不用愁</div>
      </a>
      <a class="feature-item" href="#img-5">
        <div class="label">平台托底</div>
        <div class="value">问题工程兜底，我们负责到底</div>
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* Floating button bar */
.feature-pill {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: max(16px, env(safe-area-inset-bottom));
  display: flex;
  gap: 4px;
  border-radius: 24px;
  background: rgba(244, 250, 255, 1);
  opacity: .85;
  backdrop-filter: blur(8px);
  box-shadow: 0 12px 30px rgba(2, 6, 23, 0.12);
  align-items: stretch;
  max-width: 1300px;
  width: min(1668px, calc(100vw - 48px));
  z-index: 900;
}

.feature-item {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 18px 10px;
  border-radius: 18px;
  text-decoration: none;
  background: transparent
}

.feature-item .label {
  font-size: 28px;
  margin-bottom: 8px;
  color: #262626;
  font-family: PingFang SC;
  font-weight: 600;
  font-style: Semibold;
  font-size: clamp(18px, .32rem, 28px);
  leading-trim: NONE;
  line-height: 1.25;
  text-align: center;
}

.feature-item .value {
  font-size: 20px;
  color: #595959;
  font-family: PingFang SC;
  font-weight: 400;
  font-style: Regular;
  font-size: clamp(12px, .18rem, 16px);
  leading-trim: NONE;
  line-height: 1.35;
  text-align: center;
  padding: 0;
  vertical-align: middle;
}

.feature-item:hover {
  background: rgba(15, 23, 42, 0.04)
}

.feature-item:active {
  background: rgba(15, 23, 42, 0.06)
}

.feature-item+.feature-item {
  border-left: 1px solid rgba(2, 6, 23, 0.04)
}

/* Keep an accessible footer at page end */
.site-footer {
  background: transparent;
  color: #94a3b8;
  padding: 36px 0 60px;
  margin-top: 40px;
  text-align: center
}

.footer-inner {
  display: flex;
  justify-content: center
}

.site-footer p {
  margin: 0;
  color: #6b7280
}

@media (max-width: 900px), (max-height: 680px) {
  .feature-pill {
    width: min(1300px, calc(100vw - 32px));
    bottom: max(12px, env(safe-area-inset-bottom));
    border-radius: 18px;
  }

  .feature-item {
    padding: 10px 6px;
    border-radius: 14px;
  }

  .feature-item .label {
    margin-bottom: 4px;
    font-size: clamp(16px, .26rem, 22px);
  }

  .feature-item .value {
    font-size: 12px;
    line-height: 1.25;
  }
}
</style>
